import UserChipSelect from "@app/shared/components/UserChipSelect";
import { UserTag } from "@app/shared/components/UserTag";
import { type ColumnDef } from "@design-system/Table";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { keys, RESOURCE_NAME } from "../../../i18n";

import { useQuestionAssignmentUpdate } from "@app/screens/ExternalQuestionnaires/externalQuestionnaire/data";
import { type QuestionnaireOverviewData } from "@app/screens/ExternalQuestionnaires/externalQuestionnaire/types";
import { Text } from "@design-system/Typography/Text";
import { AnswerStatus } from "@generated/client/graphql";
export const ownerCol: ColumnDef<QuestionnaireOverviewData[number]> = {
    id: "owner",
    meta: {
        colWidth: "150px",
        cellClassName: "min-w-[150px] max-w-[150px]",
        headerClassName: "min-w-[150px] max-w-[150px]",
    },
    accessorKey: "ownerId",
    filterFn: (row, columnId, filterValue) => {
        if (columnId !== "owner" || !Array.isArray(filterValue)) {
            return true;
        }
        if (filterValue.includes(null) && !row.original.ownerId?.length) {
            return true;
        }
        return (
            filterValue.length === 0 ||
            filterValue.includes(row.original.ownerId)
        );
    },
    header: () => {
        const { t } = useTranslation(RESOURCE_NAME);
        return (
            <Text className="text-secondary" variant="body-sm-bold">
                {t(keys.table_header_owner)}
            </Text>
        );
    },
    cell: ({ row }) => {
        const { t } = useTranslation(RESOURCE_NAME);
        const { id } = row.original;
        const [searchFilter, setSearchFilter] = useState<string>();
        const [ownerId, setOwnerId] = useState<string | undefined>(
            row.original.ownerId ?? undefined,
        );

        const { updateQuestion } = useQuestionAssignmentUpdate(
            row.original?.questionnaireId ?? undefined,
        );

        useEffect(() => {
            setOwnerId(row.original.ownerId ?? undefined);
        }, [row.original.ownerId]);

        const onUserIdChange = (userId: string) => {
            setOwnerId(userId);
            updateQuestion({ id, input: { ownerId: userId } });
        };

        const isQuestionValidated =
            row.original.answer?.status == AnswerStatus.Validated;

        return (
            <div>
                <UserChipSelect
                    userId={ownerId}
                    setUserId={onUserIdChange}
                    searchFilter={searchFilter}
                    onSearchFilterChange={setSearchFilter}
                    disabled={isQuestionValidated}
                    trigger={
                        <UserTag
                            className={
                                isQuestionValidated ? "" : "cursor-pointer"
                            }
                            userId={ownerId ?? undefined}
                            noUserText={t(keys.table_owner_assign_no_owner)}
                            isTrigger
                        />
                    }
                />
            </div>
        );
    },
};
